import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getSupportList = (params) => {
    return axios.get(`${backendHost}/api/admin/support/list`, {params});
};

export {
    getSupportList
}